import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
    ELIGIBILITY_FACTOR_ITEM_TEST_ID_PREFIX,
    ELIGIBILITY_FACTOR_ITEM_TEXT_TEST_ID_PREFIX,
    getEligibilityFactorTestIdSuffix,
} from '@modules/crm-application-eligibility/eligibilityFactorTestIds';

function EligibilityFactors(props: { factors: string; testIdDisambiguator?: number }) {
    const { factors: eligibilityFactDescription, testIdDisambiguator } = props;
    const testIdSuffix = getEligibilityFactorTestIdSuffix(eligibilityFactDescription, testIdDisambiguator);

    const RenderFactor = () => {
        return (
            <li data-testid={`${ELIGIBILITY_FACTOR_ITEM_TEST_ID_PREFIX}${testIdSuffix}`}>
                <span data-testid={`${ELIGIBILITY_FACTOR_ITEM_TEXT_TEST_ID_PREFIX}${testIdSuffix}`}>
                    <FormattedMessage
                        id={eligibilityFactDescription}
                    />
                </span>
            </li>
        );

    };

    return (
        <RenderFactor />
    );
}

export default EligibilityFactors;
